<template>
<div class="micad_gallery">
  <div class="micad_gallery_header">
    <h2 class="micad_gallery_header_title">{{galleryHeading}}</h2>
  </div>
  <div class="micad_gallery_body">
    <img :src="getImgUrl(items[0])" v-bind:alt="items[0]">
    <div class="micad_gallery_body_control micad_gallery_body_previous"></div>
    <div class="micad_gallery_body_control micad_gallery_body_next"></div>
    <div class="micad_gallery_body_indexMark">1 of 12</div>
  </div>
  <div class="micad_gallery_footer">
      <p class="micad_gallery_footer_description">{{galleryDescription}}</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'Gallery',
  data() {
    return {
      galleryHeading: "Gallery heading",
      galleryDescription: "Gallery Description",
      items: ["building1.png", "building2.jpg", "building3.jpg"],
    }
  },
  methods: {
   getImgUrl(image) {
    return '../assets/'+image
    //return require('~@/assets/'+image)
  }
 }
};
</script>

